import { useQuery } from "@tanstack/react-query";
import { fetchFirmAgenda } from "../api/firmDeadlines";
import type { AgendaResult } from "../api/firmDeadlines";

export function useFirmAgenda() {
  return useQuery<AgendaResult>({
    queryKey: ["firm", "agenda"],
    queryFn: fetchFirmAgenda,
    staleTime: 60_000,
  });
}
